import { trpc } from '@tencent/tpro_rmonitor_web_server_rum_service';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';

import IGetDimensionListReq = trpc.rmonitor.web_server.IGetDimensionListReq;
import IGetDimensionListRsp = trpc.rmonitor.web_server.IGetDimensionListRsp;

export type IGetLogIssueListReq = WithTypeCast<trpc.rmonitor.web_server.IGetLogIssueListReq>;
export type IGetLogIssueListRsp = WithTypeCast<trpc.rmonitor.web_server.IGetLogIssueListRsp>;
export type ILogIssueInfo = WithTypeCast<trpc.rmonitor.web_server.ILogIssueInfo>;
export type IGetDashboardListReq = WithTypeCast<trpc.rmonitor.web_server.IGetDashboardListReq>;
export type IGetDashboardListRsp = WithTypeCast<trpc.rmonitor.web_server.IGetDashboardListRsp>;
export type IGetMetricsReq = WithTypeCast<trpc.rmonitor.web_server.IGetMetricsReq>;
export type IGetMetricsRsp = WithTypeCast<trpc.rmonitor.web_server.IGetMetricsRsp>;
export type IGetElapsedTimeKeysReq = WithTypeCast<trpc.rmonitor.web_server.IGetElapsedTimeKeysReq>;
export type IGetElapsedTimeKeysRsp = WithTypeCast<trpc.rmonitor.web_server.IGetElapsedTimeKeysRsp>;
export type IDashboardData = WithTypeCast<trpc.rmonitor.web_server.IDashboardData>;
export type IDimensionInfo = WithTypeCast<trpc.rmonitor.web_server.IDimensionInfo>;
export type IDimensionData = WithTypeCast<trpc.rmonitor.web_server.GetDimensionListRsp.IDimensionData>;
export type IMetricData = WithTypeCast<trpc.rmonitor.web_server.GetMetricsRsp.IMetricData>;
export type DimensionType = WithTypeCast<trpc.rmonitor.web_server.DimensionType>;
export const { DimensionType } = trpc.rmonitor.web_server;
export const { SubLogType } = trpc.rmonitor.web_server;
export type SubLogType = trpc.rmonitor.web_server.SubLogType;

export interface IIssueList extends trpc.rmonitor.web_server.ILogIssueInfo{
  rowKey: string
}

/**
 * 产品成员管理
 */
export class RumService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.RumService,
    });
  }

  /**
   * 获取日志列表
   * @param req
   */
  public async getLogIssueList(req: IGetLogIssueListReq): Promise<IGetLogIssueListRsp> {
    try {
      return await this.trpcPost('GetLogIssueList', req);
    } catch (e) {
      console.log('GetLogIssueList', e);
      return {
        total: 0,
        issueList: [],
      };
    }
  }

  /**
   * 获取多维分组
   * @param req
   */
  public async getDimensionList(req: IGetDimensionListReq): Promise<IGetDimensionListRsp> {
    try {
      const res = await this.trpcPost('GetDimensionList', req);

      return {
        ...res,
        data: res.data.map((item: IDimensionData) => ({
          ...item,
          docTotal: res.docTotal,
          qimeiTotal: res.qimeiTotal,
        })),
      };
    } catch (e) {
      console.log('GetDimensionList', e);
      return {
        total: 0,
        docTotal: 0,
        qimeiTotal: 0,
        data: null,
      };
    }
  }

  /**
   * 获取趋势分析
   * @param req
   */
  public async getDashboardList(req: IGetDashboardListReq): Promise<IGetDashboardListRsp | null> {
    try {
      return await this.trpcPost('GetDashboardList', req);
    } catch (e) {
      console.log('GetDashboardList', e);
      return null;
    }
  }

  /**
   * 获取指标分析
   * @param req
   */
  public async getMetrics(req: any): Promise<IGetMetricsRsp | null> {
    try {
      return await this.trpcPost('GetMetrics', req);
    } catch (e) {
      console.log('GetMetrics', e);
      return null;
    }
  }

  /**
   * 获取动态阶段名
   */
  public async getElapsedTimeKeys(req: IGetElapsedTimeKeysReq): Promise<IGetElapsedTimeKeysRsp | null> {
    try {
      return await this.trpcPost('GetElapsedTimeKeys', req);
    } catch (e) {
      console.log('GetElapsedTimeKeys', e);
      return null;
    }
  }
}

export const rumService = new RumService();
